import { useUserContext } from "@/contexts/user";
import { useEffect, useRef, useState } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogCancel, AlertDialogAction, AlertDialogHeader, AlertDialogFooter, AlertDialogDescription } from "./ui/alert-dialog";
import { config } from "@/config";
import { enablePush } from "@/utils/pushSubscriptionUtils";
import { supabase } from "@/lib/supabase/client";

export function AllowNotificationsHandler() {
    const { user } = useUserContext();

    const [showNotificationPrompt, setShouldShowPrompt] = useState<boolean>(false);
    const [isEnablingNotifications, setIsEnablingNotifications] = useState(false);

    const isEnablingNotificationsRef = useRef(false);

    useEffect(() => {
        isEnablingNotificationsRef.current = isEnablingNotifications;
    }, [isEnablingNotifications]);

    useEffect(() => {
        if (isEnablingNotificationsRef.current) return;

        (async () => {
            try {
                if (!("serviceWorker" in navigator) || !("PushManager" in window) || !user) return;

                setIsEnablingNotifications(true);

                // Don't auto-prompt; only proceed if already granted
                if (Notification.permission !== "granted") return;

                const reg = await navigator.serviceWorker.ready;
                const existing = await reg.pushManager.getSubscription();
                if (existing) return; // already subscribed

                await enablePush(supabase);
            } finally {
                setIsEnablingNotifications(false);
            }
        })();
    }, [user]);


    useEffect(() => {
        setShouldShowPrompt(
            ("Notification" in window) &&
            ("PushManager" in window) &&
            user &&
            Notification.permission === "default" &&
            localStorage.getItem("notification_prompt_dismissed") !== "true"
        );
    }, [user]);

    return (
        <AlertDialog open={showNotificationPrompt}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Godkänn notiser för att få uppdateringar från {config.appName}</AlertDialogTitle>
                    <AlertDialogDescription>
                        {/* {"Information om notiserna(?)"} */}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel
                        disabled={isEnablingNotifications}
                        onClick={() => {
                            localStorage.setItem("notification_prompt_dismissed", "true");
                            setShouldShowPrompt(false);
                        }}>Inte nu</AlertDialogCancel>
                    <AlertDialogAction
                        disabled={isEnablingNotifications}
                        onClick={async () => {
                            if (isEnablingNotifications) return;
                            setShouldShowPrompt(false);
                            setIsEnablingNotifications(true);
                            await enablePush(supabase);
                            setIsEnablingNotifications(false);
                        }}>Godkänn</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}